'use client'
import { storyblokEditable } from '@storyblok/react'
import type { SbBaseBlockProps, ExpectedBlockType } from '@/services/storyblok/storyblok'
import { filterByBlockType } from '@/services/storyblok/Storyblok.helpers'
import type { ProductPillowBlockProps } from './ProductPillowBlock'
import { ProductPillowBlock } from './ProductPillowBlock'
import { wrapper, scrollerContent, scrollerPlatter, scrollerItem } from './ProductPillowsBlock.css'

export type ProductPillowsBlockProps = SbBaseBlockProps<{
  items: ExpectedBlockType<ProductPillowBlockProps>
}>

export const ProductPillowsBlock = ({ blok }: ProductPillowsBlockProps) => {
  const items = filterByBlockType(blok.items, ProductPillowBlock.blockName)
  return (
    <div className={wrapper} {...storyblokEditable(blok)}>
      <div className={scrollerContent}>
        <div className={scrollerPlatter} role="list">
          {items.map((nestedBlock) => (
            <div key={nestedBlock._uid} className={scrollerItem} role="listitem">
              <ProductPillowBlock blok={nestedBlock} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

ProductPillowsBlock.blockName = 'productPillows'
